export const TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';
export const CLOSE_NAVBAR = 'CLOSE_NAVBAR';
export const OPEN_NAVBAR = 'OPEN_NAVBAR';

export function toggleNavbar() {
  return {
    type: TOGGLE_NAVBAR
  };
}

export function closeNavbar() {
  return {
    type: CLOSE_NAVBAR,
    payload: {
      collapsedNavbar: true
    }
  };
}

export function openNavbar() {
  return {
    type: OPEN_NAVBAR,
    payload: {
      collapsedNavbar: false
    }
  };
}



// WEBPACK FOOTER //
// ./src/Actions/Navigation.js